import React from 'react';
import { Select } from '@fourthwall/components';
import { timezones } from '@fourthwall/utils/dist/timezone';
const timezoneOptions = timezones.map((timezone) => ({
    label: timezone.label,
    value: timezone.name,
}));
export const TimezoneSelect = (props) => {
    return React.createElement(Select, { ...props, options: timezoneOptions });
};
